import "./HomeSkeleton.css";

import HeroSliderSkeleton from "../HeroSlider/HeroSliderSkeleton";
import SpecialOfferSkeleton from "../SpecialOffers/SpecialOfferSkeleton";
import CategorySkeleton from "../Categories/CategorySkeleton";
import BannerSkeleton from "../PromotionalBanners/BannerSkeleton";
import HomeContainer from "../HomeContainer/HomeContainer";
import PromotionalBannersSkeleton from "./PromotionalBannersSkeleton/PromotionalBannersSkeleton";
import ProductTabsSkeleton from "./ProductTabsSkeleton/ProductTabsSkeleton";
import BrandsSkeleton from "./BrandsSkeleton/BrandsSkeleton";
import ArticlesSkeleton from "./ArticlesSkeleton/ArticlesSkeleton";

export default function HomeSkeleton() {
  return (
    <>
      <HomeContainer>
        
        <HeroSliderSkeleton />

        <PromotionalBannersSkeleton count={2} columns={2} />

        <ProductTabsSkeleton productCount={4} tabCount={4} />

        <BrandsSkeleton count={8} />

        <HomeContainer>
          <PromotionalBannersSkeleton count={2} columns={2} />

          <ProductTabsSkeleton productCount={4} tabCount={4} />

          <CategorySkeleton />

          <ArticlesSkeleton desktopArticleCount={6} mobileArticleCount={4} />
        </HomeContainer>
      </HomeContainer>
    </>
  );
}
